import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { StyleObject } from 'styletron-standard';

import ActivitySaleAddOnsTable from './addons-table';
import ActivitySaleItem from './detail-table';
import ActivitySaleGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../../style';

export default function ActivityGuestCard() {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const activitySales = useWatch({
    control,
    name: 'approvalable.activitySales',
  });

  return (
    <>
      {activitySales.map((activitySale, idx) => (
        <React.Fragment key={activitySale.id}>
          <CardSection>
            <ScheduleCardHeader $style={style}>
              <Text variant="HeadingXSmall">
                {t('common:other_sale_detail')} {idx + 1}
              </Text>
              <Input
                type="check-box"
                name={`approvalable.activitySales.${idx}.isGroupedPrice`}
                label={t('ticketSales:grouped_price')}
                noMargin
              />
            </ScheduleCardHeader>
            <Separator gap={24} />
            <ActivitySaleGuestTable parentIndex={idx} />
            <Separator gap={24} />
            <ActivitySaleItem parentIndex={idx} />
            <Separator gap={24} />
            <ActivitySaleAddOnsTable parentIndex={idx} />
          </CardSection>
          <Separator gap={24} />
        </React.Fragment>
      ))}
    </>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};
